import React from 'react'
import {connect} from 'react-redux'
import styled from 'styled-components'
import {Link} from 'react-router-dom'
import MenuItem from '@mui/material/MenuItem'
import Snackbar from '@mui/material/Snackbar'
import Select from '@mui/material/Select'
import Tooltip from '@mui/material/Tooltip'
import {Settings, CloudDownload} from '@mui/icons-material'
import {injectIntl} from 'react-intl'
import DesktopHeader from 'containers/Header/Desktop'
import MobileHeader from 'containers/Header/Mobile'
import Dialog from 'components/Dialog'
import Sidebar from 'containers/Sidebar'
import Grid from 'components/Grid'
import ModulesList from 'components/ModulesList'
import CreateCard from 'components/CreateCard'
import ListConfig from 'components/ListConfig'
import WidgetConfig from 'components/WidgetConfig'
import GraphicConfig from 'components/GraphicConfig'
import PlanningConfig from 'components/PlanningConfig'
import SchedulerConfig from 'components/SchedulerConfig'
import ExcelImport from 'components/ExcelImport'
import ModuleEmpty from 'components/ModuleEmpty'
import Empty from 'components/Empty'
import Search from 'components/Search'
import {changeApplication} from 'modules/applications/actions'
import {resetViews} from 'modules/collection/actions'
import {
    fetchModules,
    resetModuleNotification,
    createModule,
    deleteModule,
    updateModule,
    changeModule,
    getRollup,
    fetchReorderModules,
    getSheets,
    importExcel,
    resetSheets,
    copyCard
} from 'modules/modules/actions'
import {excelBackup} from 'modules/excel/actions'
import {isMobile, filterCards, debounce} from 'utils/utils'
import {cards} from 'utils/helpers'
import route from 'utils/enums/route'

const Name = styled.div`
    display: flex;
    align-items: center;
    margin-right: auto;
    font-weight: 700;
    font-size: 20px;
    overflow: hidden;

    > div {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`

const SubMenu = styled.div`
    bottom: 0;
    position: absolute;
    width: 100%;
    background-color: rgba(0, 0, 0, .4);
    height: 60px;
    display: flex;
    padding: 10px 20px;
    box-sizing: border-box;
    align-items: center;

    svg {
        margin-right: 20px;
        font-size: 27px;
        color: rgba(255, 255, 255, .7);
        cursor: pointer;

        :hover {
            color: #ffc300;
        }
    }
`

const Container = styled.section`
    margin-top: ${props => props.mobile ? '60px' : '117px'};
    padding: ${props => props.mobile ? 0 : '0px 0px 0px 256px'};
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    -webkit-overflow-scrolling: touch;
`

const Input = styled.input`
    position: absolute;
    width: 0;
    height: 0;
    top: 0;
    visibility: hidden;
`

const Title = styled.div`
    color: #A0B7BE;
    padding: 15px;
    text-transform: uppercase;
    letter-spacing: 2px;
`

const Apps = styled(Select)`
	position: absolute;
	top: 80px;
	margin: 0 20px;
	color: white;
	max-width: 200px;
	line-height: normal;
	font-size: 20px;

	& .MuiSelect-icon {
		color: white;
	}
`

class Main extends React.Component {
    constructor(props) {
        super(props)

		this.mobile = isMobile()
		this.search = React.createRef()
		this.result = []

        this.state = {
            openDialog: null,
            openId: null,
			pattern: ''
        }
    }

    componentDidMount() {
        if (!this.mobile) {
            this.props.fetchModules()
        }
    }

    componentDidUpdate(props) {
        if (props.current && this.props.current !== props.current) {
            this.getCurrentMod()
			if (!this.mobile) {
				this.resetFilter()
			}
        }

        if (this.props.createdModuleSuccess) {
            this.props.navigate(`/${route.Module}/${this.props.createdModuleSuccess}`)
            this.props.resetModuleNotification()
        }

        if (this.props.updatedCardSuccess) {
            this.props.resetModuleNotification()
        }

		if (this.props.modules.length && !this.props.modules.find(item => item.id === Number(this.props.params.id))) {
			this.getCurrentMod()
		}

        if (this.props.entityId && this.props.entityId !== props.entityId) {
            this.props.navigate(`/${route.Table}/${this.props.entityId}`)
        }
    }

	getCurrentMod = () => {
		const current = this.props.modules.find(item => item.isDefault)
		const id = current ? current.id : this.props.modules[0].id
		this.props.navigate(`/${route.Module}/${id}`, {replace: true})
	}

    handleChange = (e) => {
        this.props.changeApplication(e.target.value)
		this.props.resetViews()
    }

    handleClose = () => {
        this.setState({
            openDialog: null,
            openId: null
        })
    }

    handleOpen = (type, id) => {
        if (type === 'excel') {
            this.setState({
                openDialog: type
            }, () => this.input.click())
        } else {
            this.setState({
                openDialog: type,
                openId: id
            })
        }
    }

    handleDownload = (e) => {
        const file = e.currentTarget.files[0]

        if (file) {
            this.setState({ openDialog: null })
            this.props.getSheets(file, Number(this.props.params.id))
        }
    }

	setFilter = debounce((value) => {
		this.result = filterCards(value, this.props.modules)

        this.setState({
            pattern: value
        })
    }, 300)

	resetFilter = () => {
		this.result = []
		this.search.current.value = ''
        this.setState({
            pattern: ''
        })
    }

    render() {
        const {intl, permissions} = this.props
        const currentModule = this.props.modules.find(item => item.id === Number(this.props.params.id))

        return (
            <React.Fragment>
                {this.mobile ?
                    <MobileHeader
                        logo={this.props.logo}
                        module={currentModule && currentModule.id}
                    />
                    :
                    <DesktopHeader padding={global.SIDE_BAR_NORMAL_WIDTH}>
                        <Name>
                            <div>{currentModule && currentModule.name}</div>
                        </Name>
						<Search value={this.state.pattern}
							onClick={this.resetFilter}
							onChange={(e) => this.setFilter(e.target.value)}
							ref={this.search}
							style={{marginLeft: '16px'}}
						/>
                    </DesktopHeader>
                }
                {!this.mobile &&
                    <Sidebar logo={this.props.logo}>
                        {this.props.applications.length > 1 &&
                            <Apps
                                value={this.props.current}
                                onChange={this.handleChange}
								variant="standard"
								disableUnderline={true}
                            >
                                {this.props.applications.map((item, index) =>
                                    <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                )}
                            </Apps>
                        }
                        <ModulesList
							search={!!this.state.pattern}
                            modules={this.props.modules}
                            currentModule={currentModule}
                            createModule={this.props.createModule}
                            deleteModule={this.props.deleteModule}
                            updateModule={this.props.updateModule}
                            permissions={permissions}
                            onReorderModules={this.props.fetchReorderModules}
							resetFilter={this.resetFilter}
                            // updating={this.props.createdModuleSuccess}
                        />
                        <SubMenu>
                            {permissions.Admin &&
                                <Tooltip
                                    title={intl.formatMessage({id: "main.settings"})}
                                    placement="top"
                                >
                                    <Link style={{display: 'flex'}} to={'/settings/main'}>
                                        <Settings />
                                    </Link>
                                </Tooltip>
                            }
                            {permissions.Designer &&
                                <Tooltip
                                    title={intl.formatMessage({id: "main.global_backup"})}
                                    placement="top"
                                >
                                    <CloudDownload onClick={this.props.excelBackup} />
                                </Tooltip>
                            }
                        </SubMenu>
                    </Sidebar>
                }
                {currentModule &&
                    <React.Fragment>
                        <Container mobile={this.mobile}>
                            {!this.mobile && permissions.Designer && !this.state.pattern &&
                                <CreateCard
                                    handleOpen={this.handleOpen}
                                />
                            }
                            {this.mobile &&
                                <React.Fragment>
                                    {this.props.applications.length > 1 &&
                                        <Select
                                            value={this.props.current}
                                            onChange={this.handleChange}
											disableUnderline={true}
											variant="standard"
                                            sx={{fontSize: '20px', margin: '10px 10px 0 10px', alignSelf: 'flex-start'}}
                                        >
                                            {this.props.applications.map((item, index) =>
                                                <MenuItem key={index} value={item.id}>{item.name}</MenuItem>
                                            )}
                                        </Select>
                                    }
                                </React.Fragment>
                            }
							{!this.state.pattern ?
								<React.Fragment>
									 {!!currentModule.cards.length &&
										<Grid
											layoutCards={currentModule.cards}
											layoutCfg={currentModule.layout && currentModule.layout.length ? currentModule.layout : []}
											getRollup={this.props.getRollup}
											handleChangeLayout={(layout) => this.props.updateModule({
												name: currentModule.name,
												icon: currentModule.icon,
												isDefault: currentModule.isDefault,
												id: currentModule.id,
												layout: [...layout]
											})}
											handleChangeModule={this.props.changeModule}
											isDesigner={permissions.Designer}
											currentModule={currentModule.id}
											editDialogOpen={this.handleOpen}
											updatingCard={this.props.updatedCardSuccess}
											mobile={this.mobile}
											rollups={this.props.rollups}
											handleCopy={this.props.copyCard}
											editable={true}
										/>
									}
									{!currentModule.cards.length &&
										<ModuleEmpty
											isDesigner={permissions.Designer}
											handleOpen={this.handleOpen}
											mobile={this.mobile}
										/>
									}
								</React.Fragment> :
								<React.Fragment>
									{!this.result.modules.length && !this.result.entities.length ?
										<Empty /> :
										<div style={{marginTop: '20px'}}>
											{this.result.modules.map(item =>
												<div key={item.id}>
													<Title>
														{item.name}
													</Title>
													{!!item.cards.length &&
														<Grid
                                                            layoutCards={item.cards}
															layoutCfg={[]}
															getRollup={this.props.getRollup}
															isDesigner={permissions.Designer}
															currentModule={item.id}
															mobile={this.mobile}
															rollups={this.props.rollups}
															editable={false}
														/>
													}
												</div>
											)}
											{!!this.result.entities.length &&
												<React.Fragment>
													<Title>
														{intl.formatMessage({id: "main.tables"})}
													</Title>
													<Grid
														layoutCards={this.result.entities}
														layoutCfg={[]}
														isDesigner={permissions.Designer}
														mobile={this.mobile}
														editable={false}
													/>
												</React.Fragment>
											}
										</div>
									}
								</React.Fragment>
							}  
                        </Container>
                        <Dialog
                            fullWidth={true}
                            open={!!this.state.openDialog && this.state.openDialog !== 'excel'}
                            onClose={this.handleClose}
                        >
                            {this.state.openDialog === cards.List ?
                                <ListConfig
                                    entities={this.props.entities}
                                    currentModule={currentModule.id}
                                    handleClose={this.handleClose}
                                    cardId={this.state.openId}
                                    card={currentModule.cards.find(item => item.id === this.state.openId)}
                                    type={cards.List}
                                />
                            : this.state.openDialog === cards.Widget ?
                                <WidgetConfig
                                    currentModule={currentModule.id}
                                    handleClose={this.handleClose}
                                    cardId={this.state.openId}
                                    card={currentModule.cards.find(item => item.id === this.state.openId)}
                                    type={cards.Widget}
                                />
                            : this.state.openDialog === cards.Graphic ?
                                <GraphicConfig
                                    entities={this.props.entities}
                                    currentModule={currentModule.id}
                                    handleClose={this.handleClose}
                                    cardId={this.state.openId}
                                    card={currentModule.cards.find(item => item.id === this.state.openId)}
                                    type={cards.Graphic}
                                />
                            : this.state.openDialog === cards.Planning ?
                                <PlanningConfig
                                    currentModule={currentModule.id}
                                    handleClose={this.handleClose}
                                    type={cards.Planning}
                                />
                            : this.state.openDialog === cards.Scheduler ?
                                <SchedulerConfig
                                    currentModule={currentModule.id}
                                    handleClose={this.handleClose}
                                    type={cards.Scheduler}
                                />
                            : <div />
                            }
                        </Dialog>
                        {this.state.openDialog === 'excel' &&
                            <Input
                                type='file'
                                accept=".xlsx"
                                onChange={this.handleDownload}
                                ref={el => this.input = el}
                            />
                        }
                        {!!this.props.sheets &&
                            <Dialog
                                fullWidth={true}
                                open={!!this.props.sheets}
                                onClose={this.props.resetSheets}
                            >
                                <ExcelImport
                                    currentModule={currentModule.id}
                                    handleClose={this.props.resetSheets}
                                    sheets={this.props.sheets}
                                    fileName={this.props.fileName}
                                    importExcel={this.props.importExcel}
                                    entities={this.props.entities}
                                />
                            </Dialog>
                        }
                        <Snackbar
                            anchorOrigin={{
                                vertical: 'bottom',
                                horizontal: 'center',
                            }}
                            onClose={this.props.resetSheets}
                            open={!!this.props.sheets && !this.props.sheets.length}
                            autoHideDuration={2000}
                            message={intl.formatMessage({id: "main.excel_invalid"})}
                        />
                    </React.Fragment>
                }
            </React.Fragment>
        )
    }
}

const mapStateToProps = ({login, applications, modules, entities}) => ({
    current: applications.current,
    applications: applications.data,
    logo: applications.logo,
    modules: modules.modules,
    permissions: login.permissions,
    createdModuleSuccess: modules.createdModuleSuccess,
    updatedCardSuccess: modules.updatedCardSuccess,
    rollups: modules.rollups,
    sheets: modules.sheets,
    fileName: modules.fileName,
    entityId: modules.entityId,
    entities: entities.entities
})

export default connect(mapStateToProps, {
    changeApplication,
    fetchModules,
    resetModuleNotification,
    createModule,
    deleteModule,
    updateModule,
    changeModule,
    getRollup,
    fetchReorderModules,
    getSheets,
    importExcel,
    resetSheets,
    excelBackup,
    copyCard,
	resetViews
})(injectIntl(Main))
